module.exports = __webpack_public_path__ + "img/alignLeft.4f64a1a2.svg";